module.exports = __webpack_public_path__ + "static/media/student-badge-back.a6f24e7d.jpg";